import { Badge } from '../../engine/design/primitives/Misc';

// The ticket list's summary cell: the summary plus what needs attention at a glance — overdue
// against its resolution target, or no first reply yet against the response target. Pure display
// over fields every ticket row carries (NovaPSA's or a connected system's).

type Row = Record<string, unknown>;

export function summaryFlags(row: Row, now = Date.now()): { key: string; label: string; tone: 'neg' | 'warn' }[] {
  const out: { key: string; label: string; tone: 'neg' | 'warn' }[] = [];
  const closed = Boolean(row['closed_at'] ?? row['resolved_at']);
  const fix = typeof row['resolution_due_at'] === 'string' ? Date.parse(row['resolution_due_at']) : NaN;
  if (!closed && Number.isFinite(fix) && fix < now) out.push({ key: 'overdue', label: 'Overdue', tone: 'neg' });
  if (!closed && !row['responded_at'] && typeof row['first_response_due_at'] === 'string') out.push({ key: 'no-reply', label: 'No reply yet', tone: 'warn' });
  return out;
}

export function TicketSummary({ row }: { row: Row }) {
  const flags = summaryFlags(row);
  return (
    <span className="hf-row" style={{ gap: 'var(--s-2)', minWidth: 0 }}>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{String(row['summary'] ?? '')}</span>
      {flags.map((f) => (
        <Badge key={f.key} tone={f.tone} dot={false}>{f.label}</Badge>
      ))}
    </span>
  );
}
